module.exports = __webpack_public_path__ + "static/media/26d1.40cc267c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/emoji/26d1.svg
// module id = 631
// module chunks = 1